module.exports = __webpack_public_path__ + "static/media/Mini Project EXTC 21-22.d8907c44.pdf";